import React from "react";
import styled from "styled-components";

const BarShell = styled.div<{background?: string}>`
  width: 100%;
  background: ${({background}) => background ?? "#e9ecef"};
  border-radius: 8px;
  height: 20px;
  position: relative;
  overflow: hidden;
`;

const BarFill = styled.div<{color?: string; ratio: number}>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ratio}) => Math.min(100, Math.max(0, ratio * 100))}%;
  background: ${({color}) => color ?? "linear-gradient(90deg, #74c0fc, #228be6)"};
  transition: width 0.25s ease;
`;

const BarLabel = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #212529;
  font-weight: 600;
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.8);
`;

const Header = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
`;

const Title = styled.span`
  font-weight: 700;
  color: #212529;
`;

const Note = styled.span`
  color: #495057;
  font-size: 12px;
`;

const Footer = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: #495057;
`;

export type FlowBarProps = {
    title: string;
    value: number;
    capacity: number;
    unit?: string;
    color?: string;
    background?: string;
    footer?: React.ReactNode;
};

export function FlowBar({title, value, capacity, unit = "", color, background, footer}: FlowBarProps) {
    const ratio = capacity === 0 ? 0 : value / capacity;
    const formattedValue = `${value.toFixed(1)}${unit}`;
    const formattedCapacity = `${capacity.toFixed(1)}${unit}`;

    return <div>
        <Header>
            <Title>{title}</Title>
            <Note>{formattedValue} / {formattedCapacity}</Note>
        </Header>
        <BarShell background={background}>
            <BarFill ratio={ratio} color={color}/>
            <BarLabel>{formattedValue} / {formattedCapacity}</BarLabel>
        </BarShell>
        {footer && <Footer>{footer}</Footer>}
    </div>;
}
